var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155px",
    height: "188px",
    viewBox: "0 0 155 188",
    enableBackground: "new 0 0 155 188",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CED500",
    d: "M40.587,102.818l40.589,40.588H0L40.587,102.818z M81.125,41.438H40.737L9.997,72.079l30.59,30.74 l40.587-40.537V41.439L81.125,41.438L81.125,41.438z M81.125,94.321h73.777L81.125,168.1V94.321z M81.176,41.438V1l40.438,40.438 H81.176z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8CBD22",
    d: "M81.176,143.406l-40.588-40.588l40.588-40.537V143.406z M81.176,41.438V1L40.737,41.438H81.176z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A6E6",
    d: "M81.176,143.406v44.887l-44.887-44.887H81.176L81.176,143.406z M81.176,41.438v52.884h73.777l-52.834-52.884 H81.176z M106.117,143.156h32.74v-32.74L106.117,143.156z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93990c3e56741d05f19dec630d1b9047.svg";
export { ForwardRef as ReactComponent };